// Email validation
export function validateEmail(email) {
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email) return { valid: false, message: 'Email is required' };
  if (!pattern.test(email)) return { valid: false, message: 'Please enter a valid email address' };
  return { valid: true };
}

// Phone validation (10 digits)
export function validatePhone(phone) {
  const digits = phone.replace(/\D/g, '');
  if (!phone) return { valid: false, message: 'Phone number is required' };
  if (digits.length !== 10) return { valid: false, message: 'Phone number must be 10 digits' };
  return { valid: true };
}

// Date of birth validation (must be 18+)
export function validateDateOfBirth(dob) {
  if (!dob) return { valid: false, message: 'Date of birth is required' };

  const parts = dob.split('/');
  if (parts.length !== 3) return { valid: false, message: 'Please use MM/DD/YYYY format' };

  const month = parseInt(parts[0]);
  const day = parseInt(parts[1]);
  const year = parseInt(parts[2]);

  if (month < 1 || month > 12) return { valid: false, message: 'Invalid month' };
  if (day < 1 || day > 31) return { valid: false, message: 'Invalid day' };
  if (year < 1900 || year > new Date().getFullYear()) return { valid: false, message: 'Invalid year' };

  const birthDate = new Date(year, month - 1, day);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  if (age < 18) return { valid: false, message: 'You must be at least 18 years old' };

  return { valid: true };
}

// Text validation
export function validateText(value, validation = {}, fieldType = 'text') {
  // For textarea fields, empty is OK (will send "None" to API)
  if (fieldType === 'textarea' && (!value || !value.trim())) {
    return { valid: true };
  }

  // If field is optional (required: false) and empty, it's valid
  if (validation.required === false && (!value || !value.trim())) {
    return { valid: true };
  }

  if (!value && validation.required !== false) {
    return { valid: false, message: 'This field is required' };
  }

  if (validation.minLength && value.length < validation.minLength) {
    return { valid: false, message: `Minimum ${validation.minLength} characters required` };
  }

  if (validation.maxLength && value.length > validation.maxLength) {
    return { valid: false, message: `Maximum ${validation.maxLength} characters allowed` };
  }

  if (validation.pattern && !validation.pattern.test(value)) {
    return { valid: false, message: 'Please enter a valid value' };
  }

  return { valid: true };
}

// Number validation
export function validateNumber(value, validation = {}) {
  const num = parseFloat(value);

  if (!value && validation.required !== false) {
    return { valid: false, message: 'This field is required' };
  }

  if (isNaN(num)) {
    return { valid: false, message: 'Please enter a valid number' };
  }

  if (validation.min !== undefined && num < validation.min) {
    return { valid: false, message: `Minimum value is ${validation.min}` };
  }

  if (validation.max !== undefined && num > validation.max) {
    return { valid: false, message: `Maximum value is ${validation.max}` };
  }

  return { valid: true };
}

// Checkbox validation
export function validateCheckbox(value, field = {}) {
  if (field.required && !value) {
    return { valid: false, message: 'You must check this box to continue' };
  }
  return { valid: true };
}

// Generic field validation
export function validateField(field, value) {
  switch (field.type) {
    case 'email':
      return validateEmail(value);
    case 'phone':
      return validatePhone(value);
    case 'date':
      return validateDateOfBirth(value);
    case 'number':
      return validateNumber(value, field.validation);
    case 'text':
    case 'textarea':
      // Pass field.required in validation object
      return validateText(value, { ...field.validation, required: field.required }, field.type);
    case 'checkbox':
      return validateCheckbox(value, field);
    case 'radio':
    case 'state':
    case 'height':
      if (!value && field.required) {
        return { valid: false, message: 'Please make a selection' };
      }
      return { valid: true };
    default:
      return { valid: true };
  }
}
